import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Breadcrumb = ({ user }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeMap = {
    '/admin-dashboard': { label: 'Admin Dashboard', icon: 'LayoutDashboard' },
    '/vendor-dashboard': { label: 'Vendor Dashboard', icon: 'LayoutDashboard' },
    '/product-management': { label: 'Product Management', icon: 'Package' },
    '/employee-management': { label: 'Employee Management', icon: 'Users' },
    '/user-profile-settings': { label: 'Profile Settings', icon: 'Settings' },
    '/whats-app-authentication': { label: 'Authentication', icon: 'Smartphone' }
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [];

    // Add home/dashboard as first item
    const dashboardPath = user?.role === 'admin' ? '/admin-dashboard' : '/vendor-dashboard';
    const dashboardLabel = user?.role === 'admin' ? 'Admin Dashboard' : 'Vendor Dashboard';
    
    breadcrumbs.push({
      label: dashboardLabel,
      path: dashboardPath,
      icon: 'LayoutDashboard',
      isHome: true
    });

    // Add current page if it's not the dashboard
    if (location.pathname !== dashboardPath && routeMap[location.pathname]) {
      breadcrumbs.push({
        label: routeMap[location.pathname].label,
        path: location.pathname,
        icon: routeMap[location.pathname].icon,
        isHome: false
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't show breadcrumbs on authentication page or if only one item
  if (location.pathname === '/whats-app-authentication' || breadcrumbs.length <= 1) {
    return null;
  }

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="flex items-center space-x-2 text-sm mb-6" aria-label="Breadcrumb">
      {breadcrumbs.map((crumb, index) => (
        <div key={crumb.path} className="flex items-center space-x-2">
          {index > 0 && (
            <Icon 
              name="ChevronRight" 
              size={14} 
              className="text-muted-foreground" 
            />
          )}
          
          {index === breadcrumbs.length - 1 ? (
            // Current page - not clickable
            <div className="flex items-center space-x-2 text-foreground">
              <Icon name={crumb.icon} size={16} />
              <span className="font-medium">{crumb.label}</span>
            </div>
          ) : (
            // Clickable breadcrumb
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleNavigation(crumb.path)}
              className="h-auto p-1 text-muted-foreground hover:text-white micro-animation"
            >
              <div className="flex items-center space-x-2">
                <Icon name={crumb.icon} size={16} />
                <span>{crumb.label}</span>
              </div>
            </Button>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumb;